module.exports = __webpack_public_path__ + "static/og-image-1c667a9f42f13e9a90349ae210f08e27.png";